import "./MGModalityHeader.css"


export default function MGModalityHeader({ icon, title, subscriptionActivity, leftTitle, leftAmount, rightTitle, rightAmount, rightColor = "#222324" }) {

    const gradient = () => {
        return (
            <div className="MGModalityHeader-gradient">
                <div className="MGModalityHeader-title">
                    <img src={icon} />
                    <div>
                        <h5>{title}</h5>
                        <p >{subscriptionActivity}</p>
                    </div>

                </div>
            </div>
        );
    }
    const amountsContainer = () => {
        return (
            <div className="MGModalityHeader-amount-card-container">
                <div className="MGModalityHeader-amount-container">
                    <session className="MGModalityHeader-amount" >
                        <h6>{leftTitle}</h6>
                        <h5 style={{ color: "#222324" }}>{leftAmount}</h5>
                    </session>
                    <hr className="separator" />
                    <session className="MGModalityHeader-amount" >
                        <h6>{rightTitle}</h6>
                        <h5 style={{ color: rightColor }}>{rightAmount}</h5>
                    </session>
                </div>
            </div>
        );
    }


    return (<div className="MGModalityHeader-container MGModalityHeader-base-container">
        {gradient()}
        {amountsContainer()}

    </div>);

}